import { countryCodeIsIndonesia } from './countryCodeHelper';

const ID_HELP_CENTER_REQUEST_URL =
  'https://help.glints.com/hc/id-id/requests/new';
const DEFAULT_HELP_CENTER_REQUEST_URL =
  'https://help.glints.com/hc/en-us/requests/new';

/**
 * Returns whether the current moment falls inside Glints employer support
 * working hours: Monday-Friday, 08:00 <= time < 18:00 in Asia/Jakarta (WIB).
 *
 * The schedule is fixed by product. We avoid any timezone dependency by
 * formatting the supplied Date through `Intl.DateTimeFormat`, then checking
 * the weekday and hour parts in Jakarta time.
 */
const WIB_FORMATTER = new Intl.DateTimeFormat('en-US', {
  timeZone: 'Asia/Jakarta',
  weekday: 'short',
  hour: 'numeric',
  hourCycle: 'h23',
});

const WORKING_DAYS = new Set(['Mon', 'Tue', 'Wed', 'Thu', 'Fri']);

export function isEmployerSupportWorkingHours(now: Date = new Date()): boolean {
  const parts = WIB_FORMATTER.formatToParts(now);

  const weekday = parts.find(part => part.type === 'weekday')?.value;
  const hour = Number(parts.find(part => part.type === 'hour')?.value);

  return (
    weekday !== undefined &&
    WORKING_DAYS.has(weekday) &&
    Number.isFinite(hour) &&
    hour >= 8 &&
    hour < 18
  );
}

export function getEmployerSupportHelpCenterRequestUrl(
  countryCode?: string
): string {
  return countryCodeIsIndonesia(countryCode)
    ? ID_HELP_CENTER_REQUEST_URL
    : DEFAULT_HELP_CENTER_REQUEST_URL;
}
